
import Vue from 'vue';
import _union from 'lodash/union';
import _sortBy from 'lodash/sortBy';
import { fuzzyFilter } from '@/utils/fuzzySearch';
import DialogOrBottomSheet from '@/components/base/DialogOrBottomSheet.vue';
import EmptyState from '@/components/states/EmptyState.vue';
import RunnitCarousel from '@/views/Runnits/RunnitCarousel.vue';

export default Vue.extend({
	name: 'ImageSearchDialogSelect',
	components: {
		DialogOrBottomSheet,
		EmptyState,
		RunnitCarousel,
	},
	props: {
		isOpen: { type: Boolean, default: false },
		value: { type: [Number, String, Object, Array], default: null },
		options: { type: Array, default: () => [] },
		label: { type: String, required: true },
		tooltip: { type: String, default: '' },
		placeholder: { type: String, default: '' },
		required: { type: Boolean, default: false },
		rules: { type: Object, default: () => ({}) },
	},
	data () {
		return {
			selectedFilterKey: 'ALL',
			searchText: '',
		};
	},
	computed: {
		selectedValue () {
			return this.value ? this.options.find((option) => option.value === this.value) : null;
		},
		filteredOptions () {
			const optionsByCategory = this.selectedFilterKey === 'ALL' ? this.options : this.options.filter((option) => !!option.tags?.[this.selectedFilterKey]);

			if (!this.searchText) {
				return _sortBy(optionsByCategory, 'text');
			}

			return _sortBy(
				fuzzyFilter(
					optionsByCategory,
					this.searchText,
					[
						{ name: 'text', weight: 1 }
					]
				),
				'text'
			);
		},
		FILTERS_KEYS () {
			const tagKeys = this.options?.reduce((acc, option) => {
				if (option.tags) {
					return [...acc, ...Object.keys(option.tags)];
				}
				return acc;
			}, []);

			return _union(['ALL'], tagKeys);
		},
		FILTERS () {
			const filters = {
				'ALL': 'All'
			};

			this.options?.forEach(option => {
				if (option.tags) {
					Object.keys(option.tags).forEach(tag => {
						if (!filters[tag]) {
							// Convert tag to title case for display
							filters[tag] = tag.split('_')
								.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
								.join(' ');
						}
					});
				}
			});

			return filters;
		},
		filterItems () {
			return this.FILTERS_KEYS.map(key => ({
				key,
				label: this.FILTERS[key]
			}));
		},
	},
	methods: {
		closeDialog (close) {
			this.$emit('close');
			if (close) {
				close();
			}
		},
		onSelectImageOption (option: any, close: () => void) {
			this.$emit('input', option.value);
			this.closeDialog(close);
		},
	},
});
